import { Schema as S } from "effect";

import { apiData } from "../../api/asyncData";
import { Week } from "../../api/schemas/keepInTouch";
import * as Picker from "../../widgets/recordPicker";

export const Model = S.Struct({
	page: S.Literal("KeepInTouch"),
	/** The whole week payload (KTD7): cards, tracked, paused. Now-only, so no asOf tag. */
	week: apiData(Week).schema,
	/** A card action or cadence write that failed; cleared by the next action. */
	error: S.Option(S.String),
	/** Swap-with-chosen-record (R12): the card to replace, and the shared record picker (KTD3). */
	swapTarget: S.Option(S.String),
	picker: Picker.Model,
});
export type Model = typeof Model.Type;
